const zh = {
  filter: {
    webSite: '网站',
    all: '全部',
    status: '状态',
    date: '时间',
    selectDate: '选择日期',
    remitted: '打款成功',
    remitting: '打款中',
    quicklySelect: {
      lab: '快速选择',
      range: {
        today: '今天',
        lastWeek: '最近一周',
        lastMonth: '最近一个月',
        lastYear: '最近一年'
      }
    }
  },
  tableColumns: {
    withdrawalTime: '提现时间',
    paymentBatchNo: '总流水号',
    childFlowID: '子流水号',
    withdrawalFlowID: '提现流水号',
    webSite: '网站',
    groupName: '群组',
    paymentAccount: '打款账户',
    withdrawalAmount: '提现金额',
    withdrawalFee: '提现手续费',
    transferredAmount: '到账金额',
    remittanceTime: '打款时间',
    remittanceStatus: '打款状态',
    orderStatus: '订单状态',
    status: '状态',
    noData: '暂无数据'
  }
}

export default zh
